/*
 * Copyright (C) 2026 Motorola Solutions, Inc.
 * All Rights Reserved.
 * Motorola Solutions Confidential Restricted.
 */

import React, { useState } from 'react';
import Icon from '@msi/cobalt-react/icon';

interface ExpandableDescriptionProps {
  text: string;
}

export const ExpandableDescription: React.FC<ExpandableDescriptionProps> = ({ text }) => {
  const [isExpanded, setIsExpanded] = useState(false);
  
  if (!text) {
    return <span></span>;
  }
  
  return (
    <div 
      style={{ 
        display: 'flex',
        alignItems: 'center',
        gap: '8px',
        width: '100%'
      }}
    >
      <div
        style={{ 
          overflow: 'hidden', 
          textOverflow: isExpanded ? 'clip' : 'ellipsis', 
          whiteSpace: isExpanded ? 'normal' : 'nowrap',
          flex: 1,
          minWidth: 0
        }}
        title={!isExpanded ? text : undefined}
      >
        {text}
      </div>
      <span
        onClick={(e: React.MouseEvent) => {
          e.stopPropagation();
          setIsExpanded(!isExpanded);
        }}
        style={{
          cursor: 'pointer',
          flexShrink: 0,
          display: 'flex',
          alignItems: 'center'
        }}
      >
        {isExpanded ? (
          <Icon name="ic_arrow_up" size={14} />
        ) : (
          <Icon name="ic_arrow_down" size={14} color="#D3D3D3" />
        )}
      </span>
    </div>
  );
};
